import React from "react"
import { Quotes } from "phosphor-react"
import { AppText } from "~/ui/app-text"
import { TextureGrainBackground } from "~/share/components/texture-grain-background"
export enum QAndAColors {
  Blue = "Blue",
  Orange = "Orange",
  Teal = "Teal",
  Magenta = "Magenta",
  Lime = "Lime",
  Purple = "Purple",
  Red = "Red",
}

export const Q_AND_A_COLOR_VARIATIONS: Record<QAndAColors, { color: string }> = {
  [QAndAColors.Blue]: { color: "#0077FF" },
  [QAndAColors.Orange]: { color: "#E73A00" },
  [QAndAColors.Teal]: { color: "#018892" },
  [QAndAColors.Magenta]: { color: "#F41375" },
  [QAndAColors.Lime]: { color: "#388E54" },
  [QAndAColors.Purple]: { color: "#AA42FF" },
  [QAndAColors.Red]: { color: "#FF2F32" },
}

interface Props {
  qAndAColor?: string | null
  qAndAPrompt?: string | null
}

export const MessageAttachmentQAndA: React.FC<Props> = ({ qAndAColor, qAndAPrompt }) => {
  if (!qAndAPrompt) return null

  const colorKey = Object.values(QAndAColors).includes(qAndAColor as QAndAColors)
    ? (qAndAColor as QAndAColors)
    : QAndAColors.Blue
  const bgColor = Q_AND_A_COLOR_VARIATIONS[colorKey].color

  return (
    <div
      className="relative w-full overflow-hidden rounded-2xl border border-neutral-200 p-4"
      style={{ backgroundColor: bgColor }}
    >
      <TextureGrainBackground />
      <div className="flex flex-col gap-2">
        <div className="flex flex-row items-center justify-between">
          <AppText variant="h3" className="text-white opacity-70">
            Q&A
          </AppText>

          <Quotes size={20} weight="fill" className="text-white" />
        </div>
        <AppText variant="h3" className="font-bold text-white">
          {qAndAPrompt}
        </AppText>
      </div>
    </div>
  )
}
